import styled from 'styled-components';
export const Container = styled.div`
    display: flex;
    position: relative;
    width: 13rem;
    height: 15rem;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: .74rem;
    padding: .5rem;
    background-color: #f5f5f5;
    border-radius: 1rem;
    box-shadow: 0px 0px 27px -3px rgba(0,0,0,0.1);
    transition: transform 0.3s ease-in-out;
    cursor: pointer;

    .flt-image{
        top: -1.75rem;
        padding: .3rem;
        overflow: hidden;
        > div {
            display: flex;
            width: 100%;
            height: 100%;
            justify-content: center;
            align-items: center;
            border-radius: 50%;
            overflow: hidden;
            background-color:#ffffff;
            > img{
                width: 100%;
                height: 100%;
                object-fit: contain;
            }
        }
        box-shadow: 0px 10px 15px -3px rgba(0,0,0,0.1);
    }
    .doorOpen{
        display: none;
    }
    &:hover {
        .doorOpen{
            display: block;
        }
        .doorClose{
            display: none;
        }
        .bdS{
            box-shadow: 0px 10px 52px -3px rgba(0,0,0,0.1),0px 10px 15px -3px rgba(0,0,0,0.1);
        }
        z-index: 999;
        transform: scale(1.2);
    }
`;
export const Content = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    border-radius: .88rem;
    gap: .5rem;
    padding: 2rem .74rem;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    > span {
        text-align: center;
        font-size: 1rem;
        color: #1c83e2;
    }   
    > span:first-child {
        font-size: 1.2rem;
        font-weight: 700;
    }
`;

export const Floating = styled.div`
    position: absolute;
    display: flex;
    width: 4rem;
    height: 4rem;
    border-radius: 50%;
    justify-content: center;
    align-items: center;
    /* background-color:#3aa1dc;  */
    background: transparent;
`;